import React from 'react';
import { FiverrLogo } from '@fiverr-private/visuals';
import { StepWrapper as CoreStepWrapper } from '@fiverr-private/identification_core';
import { Disclaimer } from '../../../components/Disclaimer';
import { Banner } from '../../../components/Banner';
import { useStepsContext } from '../../../components/StepsContext';

interface Props {
    children: JSX.Element;
    illustration?: JSX.Element;
    showDisclaimer?: boolean;
}

export const StepWrapper = ({ children, illustration = <Banner />, showDisclaimer = false }: Props) => {
    const { goBack, hasBack } = useStepsContext();

    return (
        <CoreStepWrapper
            fiverrLogo={<FiverrLogo size="sm" />}
            illustration={illustration}
            disclaimer={<Disclaimer />}
            showDisclaimer={showDisclaimer}
            goBack={goBack}
            hasBack={hasBack}
        >
            {children}
        </CoreStepWrapper>
    );
};
